import { SwipeableDrawer } from '@mui/material'

export const SwipableContainer = ({ children, isOpened, onClose }) => (
  <SwipeableDrawer
    container={window.document.body}
    anchor="bottom"
    open={isOpened}
    onClose={onClose}
    sx={{
      '& .MuiDrawer-paper': {
        backgroundColor: 'rgba(37, 39, 45, 0.8)',
        maxHeight: '90%',
        backdropFilter: 'blur(20px)',
        width: '100%',
      },
    }}
    disableSwipeToOpen={false}
    ModalProps={{
      keepMounted: true,
    }}
  >
    {children}
  </SwipeableDrawer>
)
